(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // 获取评论轮播元素
  var testimonialSlider = document.querySelector('.cart__testimonials-slider');
  
  if (testimonialSlider) {
    // 设置初始滚动位置为0，确保从左侧开始
    testimonialSlider.scrollLeft = 0;

    let isDown = false;
    let startX;
    let scrollLeft;

    // 鼠标按下事件
    testimonialSlider.addEventListener('mousedown', (e) => {
      isDown = true;
      testimonialSlider.style.cursor = 'grabbing';
      startX = e.pageX - testimonialSlider.offsetLeft;
      scrollLeft = testimonialSlider.scrollLeft;
    });

    // 触摸开始事件
    testimonialSlider.addEventListener('touchstart', (e) => {
      isDown = true;
      startX = e.touches[0].pageX - testimonialSlider.offsetLeft;
      scrollLeft = testimonialSlider.scrollLeft;
    });

    // 鼠标离开/抬起事件
    testimonialSlider.addEventListener('mouseup', () => {
      isDown = false;
      testimonialSlider.style.cursor = '';
    });
    
    testimonialSlider.addEventListener('mouseleave', () => {
      isDown = false;
      testimonialSlider.style.cursor = '';
    });

    // 触摸结束事件
    testimonialSlider.addEventListener('touchend', () => {
      isDown = false;
    });

    // 鼠标移动事件 - 模拟滚动条拖动效果
    testimonialSlider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - testimonialSlider.offsetLeft;
      const walk = (x - startX);
      testimonialSlider.scrollLeft = scrollLeft - walk;
    });

    // 触摸移动事件 - 模拟滚动条拖动效果
    testimonialSlider.addEventListener('touchmove', (e) => {
      if (!isDown) return;
      const x = e.touches[0].pageX - testimonialSlider.offsetLeft;
      const walk = (x - startX);
      testimonialSlider.scrollLeft = scrollLeft - walk;
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
